import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '@common/app/app.config';
import { Observable, of } from 'rxjs';
import { Auction } from '@enus/model/auction';

@Injectable({
    providedIn: 'root'
})
export class AuctionService {
    url: string;
    constructor(
        protected http: HttpClient,
        @Inject(API_URL) protected baseUrl: string) {
        this.url = this.baseUrl + 'auctions/';
    }

    public getByCode$(auctionCode: string): Observable<Auction> {
        if (!auctionCode) {
            return of(null);
        }
        const url = this.url + 'code' + '/' + auctionCode;
        return this.http.get<Auction>(url);
    }
}
